import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { AvatarProps, AvatarWrapperProps } from './types/avatar';

const AvatarWrapper = styled('div')<AvatarWrapperProps>(
  {
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 'normal',
  },
  ({ width, shape, customStyle }) => {
    return {
      width: width,
      height: width,
      borderRadius: shape === 'circle' ? '50%' : shape === 'square' ? '4px' : '50%',
      ...customStyle,
    };
  }
);

const AvatarContainer = styled('div')<{ sidebar?: boolean }>(
  {
    position: 'relative',
    // maintin 1:1 aspect ratio of avatar
    paddingTop: '100%',
  },
  ({ sidebar }) =>
    sidebar && {
      zIndex: -1,
    }
);

const Img = styled('img')<{ isAdmin?: boolean; shape?: string }>(
  ({ shape }) => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: shape === 'circle' ? '50%' : '4px',
  }),
  ({ isAdmin }) =>
    isAdmin && {
      width: '100%',
      top: 0,
      left: 0,
    }
);

const BackgroundImg = styled('div')<{ src: string | undefined; shape?: string }>(
  ({ shape }) => ({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: shape === 'circle' ? '50%' : '4px',
  }),
  ({ src }) => ({
    backgroundImage: `url(${src})`,
  })
);

const Avatar: React.FC<AvatarProps> = ({
  src,
  className,
  alt,
  width,
  shape,
  customStyle,
  sidebar,
  ...rest
}): ReactElement => {
  const getImageElement = () => {
    if ('object-fit' in document.documentElement.style) {
      return <Img src={src} alt={alt || 'profile'} shape={shape} {...rest} />;
    }
    // IE
    else {
      return <BackgroundImg src={src} shape={shape} />;
    }
  };

  return (
    <AvatarWrapper className={className} width={width} shape={shape} customStyle={customStyle}>
      <AvatarContainer sidebar={sidebar}>{getImageElement()}</AvatarContainer>
    </AvatarWrapper>
  );
};

Avatar.defaultProps = {
  width: '96px',
  customStyle: {},
  shape: 'square',
};

export default Avatar;
